import { IUITKSelectItemProps } from '@uitk/angular';

export class InvoicesListDto {
  invoiceNumber = "";
  invoiceDate: Date = new Date();
  orderNumber = 0;
  invoiceAmount = 0;
  paidAmount = 0;
  balance = 0;
  paidDate: Date = new Date();
  poNumber = "";
  authorizationCode = "";
  type = "";
  paymentMethod = "";
  paymentTerms = "";
  trackingNumber = "";
  expirationDate = "";
  tokenId = "";
  lastFour = "";
  shipToContactId = "";
  shipToContactName = "";
  orderByContactName = "";
  orderbyContactId = 0;
  shiptocontactNameId = 0;
  invoiceDetails: InvoicesDetailsChildListDto[] = [];

  creditMethod: IUITKSelectItemProps | undefined;//Property for UI dropdown purpose
  ccCreditMethodList: IUITKSelectItemProps[] = [];
}

export class InvoicesDetailsChildListDto {
  item = "";
  description = "";
  quantity = 0;
  unitPrice = 0.0;
  discount = 0.0;
  taxAmount = 0.0;
  extendedPrice = 0.0;
  invoiceNumber = "";
}
